import React from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  Container,
} from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const RegisterSuccess: React.FC = () => {
  return (
    <Container component="main" maxWidth="sm">
      <Paper elevation={3} sx={{ padding: 4, mt: 8, textAlign: 'center' }}>
        <CheckCircleOutline sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
        <Typography component="h1" variant="h5" gutterBottom>
          Registration Successful!
        </Typography>
        
        <Typography variant="body1">
          Thank you for registering with our club management system. Your application has been received and is pending approval.
        </Typography>
        
        <Typography variant="body1">
          You will receive an email notification once your membership has been approved. This typically takes 1-2 business days.
        </Typography>
        
        <Box sx={{ mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            component={RouterLink}
            to="/login"
            sx={{ mr: 2 }}
          >
            Sign In
          </Button>
          
          <Button
            variant="outlined"
            component={RouterLink}
            to="/"
          >
            Home
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default RegisterSuccess;
